import React, {Component} from 'react';
import {ActionSheet,SearchBar, Modal, Button, WhiteSpace, WingBlank,NavBar,Toast,Icon} from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent';
import {throttle, parseSearchToState, parseStateToSearch} from '../../util/util';
import {Http,urls} from '../../api/index'
import './storeDetail.scss';
const isIPhone = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isWX = window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ? true:false;
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault(),
  };
}
class StoreDetail extends Component {

  constructor(props) {
    super(props);
    props.cacheLifecycles.didCache(this.componentDidCache);
    props.cacheLifecycles.didRecover(this.componentDidRecover);
    this.state = {
      storeId: 38,
      storeInfo: {},
      star: 0
    }
  }
  componentDidCache = () => {};
  componentDidRecover = () => {
    this.getStoreDetail();
  };
  componentDidMount() {
    this.getStoreDetail();
  };
  getStoreDetail(){
    const { search } =  this.props.location;
    let { storeId } = parseSearchToState(search);
    let url = urls.storeInfo;
    let where = { storeId };
    Toast.loading('Loading...');
    Http.post({ url, data:where }).then(res => {
      Toast.hide();
      this.setState({
        storeInfo: res.data,
        star: parseInt(res.data.evaluateGrade)
      })
    })
  };
  cell = (e) =>{
    const tel = e.currentTarget.getAttribute("data-tel");
    window.location.href = `tel:${tel}`;
  };
  location = (e) =>{
    this.showActionSheet();
  };
  showActionSheet = () => {
    let BUTTONS;
    if (isIPhone) {
      BUTTONS = ['百度地图', '高德地图','苹果地图', '取消'];
    }else{
      BUTTONS = ['百度地图', '高德地图', '取消'];
    }
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      // destructiveButtonIndex: BUTTONS.length - 2,
      // title: 'title',
      message: '请选择地图',
      maskClosable: true,
      'data-seed': 'logId',
      wrapProps,
    },
    (buttonIndex) => {
      // 苹果地图
      if(buttonIndex===2){
        if (isIPhone) {
          let loadTime = new Date();
          window.location.href = `http://maps.apple.com/?address=${this.state.storeInfo.storeName}-${this.state.storeInfo.address}&ll=${this.state.storeInfo.latitude},${this.state.storeInfo.longitude}&z=10&t=s`;
          setTimeout(()=>{
            let outTime = new Date()
              if(outTime - loadTime > 600){
                if(isWX){
                  window.location.href = 'https://apps.apple.com/cn/app/%E5%9C%B0%E5%9B%BE/id915056765';
                  // Toast.info('您没有安装苹果地图,请安装苹果地图后重试');
                }
              }           
          },1000)
        }
      };
      // 百度地图
      if(buttonIndex===0){
          window.location.href = `http://api.map.baidu.com/marker?location=${this.state.storeInfo.latitude},${this.state.storeInfo.longitude}&title=${this.state.storeInfo.storeName}&content=${this.state.storeInfo.address}&output=html&src=izu-M`;
      }
      // 高德地图
      if(buttonIndex===1){
          window.location.href = `https://uri.amap.com/marker?position=${this.state.storeInfo.longitude},${this.state.storeInfo.latitude}&name=${this.state.storeInfo.storeName}-${this.state.storeInfo.address}&callnative=1`;
      }
    });
  };
  render() {
    const {storeInfo,star} = this.state;
    let imgUrl = storeInfo.imgUrl && '//'+storeInfo.imgUrl.split('://')[1];
    let items = [];
    for( let i=0;i<star;i++){
      items.push(<span key={ i.toString() } className="iconfont icon-star star"></span>)
    };
    return (
      <div id="store" className="page store" >
        <div className="store-top">
            <NavBarComponent>
                <NavBar
                    mode="light"
                    icon={ <Icon type="left" color='#333' /> }
                    leftContent=""
                    onLeftClick={ () => this.props.history.goBack() }
                    >
                        门店详情
                </NavBar>
            </NavBarComponent>
        </div>
        <div className="storeContent">
          <div className="card h-shadow">
            <div className="storeImgContent">
              <div className="storeImg" style={{
                background: "url("+imgUrl+") no-repeat 0 0 / 100% 100%"
              }}>
                {/* <img src='/assets/mendianxiangqing.jpg' alt="" /> */}
              </div>
            </div>
            <div className="title font16">{storeInfo.storeName}</div>
            <div className="data">
            <div className="item">
              <div>
                <span className="iconfont icon-store icon black"></span>
                <span className="ml5 ninesix font14">{storeInfo.address}</span>
              </div>
              <span onClick={this.location} className="iconfont icon-location black"></span>
            </div>
            <div className="item">
              <div>
                <span onClick={this.cell} data-tel={storeInfo.storeTel} className="iconfont icon-phone icon black"></span>
                <span className="ml5 ninesix font14">{storeInfo.storeTel}</span>
              </div>
              <span onClick={this.cell} data-tel={storeInfo.storeTel} className="iconfont icon-cell black"></span>
            </div>
              <div className="item">
              <div>
                <span className="iconfont ml20 icon black"></span>
                <span className="ml14 ninesix font14">{storeInfo.storePhone}</span>
              </div>
              <span onClick={this.cell} data-tel={storeInfo.storePhone} className="iconfont icon-cell black"></span>
            </div>
            <div className="item">
              <div>
                <span className="iconfont icon-meditor-time icon black"></span>
                <span className="ml5 ninesix font14">{storeInfo.businessHours}</span>
              </div>
            </div>
            <div className="item">
              <div>
                <span className="iconfont icon-edit black"></span>
                <span className="ml5 ninesix font14">服务评价 {star.toFixed(2)}</span>
                {items}
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StoreDetail